<template>
    <v-row class="py-6">
        <v-col v-if="canCreatePreTrialNotice" cols="auto">
            <v-dialog width="1000px" v-model="dialog">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="gray" class="white--text">
                        <v-icon class="mr-2">add_circle_outline</v-icon>
                        <div>
                            Досудебное уведомление
                        </div>
                    </v-btn>
                </template>
                <v-card class="pa-6">
                    <div class="py-4 text-h6">Создание досудебного уведомления</div>
                    <v-textarea
                        outlined
                        name="input-7-4"
                        v-model="preTrialCommentSync"
                        no-resize
                        placeholder="Введите комментарий (Не обязательно)"
                    ></v-textarea>
                    <div class="d-flex justify-end">
                        <v-btn @click="closeDialog" color="gray" rounded class="mr-3" outlined>отмена</v-btn>
                        <v-btn @click="createPreTrialNotice" color="gray" rounded class="white--text">Сохранить</v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'DebtActionButtons',
    data: () => ({
        dialog: false
    }),
    props: {
        preTrialComment: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters('auth', ['hasPermissionTo']),
        preTrialCommentSync: {
            get() {
                return this.preTrialComment;
            },
            set(val) {
                this.$emit('update:preTrialComment', val);
            }
        },
        canCreatePreTrialNotice() {
            return this.hasPermissionTo('add_pre_trial_notice');
        }
    },
    methods: {
        createPreTrialNotice() {
            this.$emit('createPreTrialNotice');
            this.dialog = false;
        },
        closeDialog() {
            this.dialog = false;
        }
    }
};
</script>

<style scoped></style>
